import * as PIXI from 'pixi.js';
import Color from '../utils/Color';

export default class Ring {
  color = Color.BLACK;

  center = new PIXI.Point(0, 0);

  thickness = 0;

  radius = 0; // this is the outer radius

  get alpha() {
    return this.color.getAlpha();
  }

  set alpha(value) {
    this.color.setAlpha(value);
  }

  draw(graphics) {
    const color = Color.toNumber(this.color);
    if (this.thickness < this.radius) {
      const radius = Math.max(this.radius - this.thickness / 2, 0);
      graphics.lineStyle(this.thickness, color, this.alpha);
      graphics.drawCircle(this.center.x, this.center.y, radius);
    } else {
      const radius = Math.max(this.radius, 0);
      graphics.lineStyle(0, color, 0);
      graphics.beginFill(color, this.alpha);
      graphics.drawCircle(this.center.x, this.center.y, radius);
      graphics.endFill();
    }
  }
}
